
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Tout comprendre sur les différences entre campagne trafic, conversion et notoriété sur Meta",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les différences entre les campagnes notoriété, trafic et conversion sur Meta. Apprenez à choisir le bon objectif marketing, à suivre les bons KPI et à optimiser votre budget publicitaire avec ALEO, agence experte Meta Ads.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Tout comprendre sur les différences entre campagne trafic, conversion et notoriété sur Meta",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez les différences entre les campagnes notoriété, trafic et conversion sur Meta. Apprenez à choisir le bon objectif marketing, à suivre les bons KPI et à optimiser votre budget publicitaire avec ALEO, agence experte Meta Ads.",
        },
      ],
    };
  },
};
